
import { Component, Vue } from 'vue-property-decorator'
import AppButton from '@/components/AppButton.vue'
import AppTab from '@/components/AppTab.vue'
import { ChildComponentMixin } from '@/mixins'
import { Tabs } from '@/stores/modules/QueriesModule'

interface TabData {
    id: Tabs
    text: string
}

@Component({
    components: {
        AppButton,
        AppTab,
    },
})

export default class QueriesHeader extends ChildComponentMixin {
    public tabs: TabData[] = [
        {
            id: Tabs.NEW_QUERY,
            text: 'Nova query',
        },
        {
            id: Tabs.SAVED_QUERIES,
            text: 'Ver queries salvas',
        },
    ]

    get currentTab() {
        return this.$store.state.query.selectedTab
    }

    public selectTab(tab: TabData) {
        this.$store.dispatch('query/selectTab', tab.id)
    }
}
